import {
  TourActionTypes,
  IMarkWizardStepSeen,
  IDismissWizardTour,
  IMarkDashboardTourSeen,
  IDismissDashboardTour,
  IMarkRestartCycleTourSeen,
  IMarkTimerCardTourSeen,
  IMarkTimerFullScreenTourSeen,
} from './types'

export const markWizardStepSeen = (step: 1 | 2 | 3 | 4): IMarkWizardStepSeen => ({
  type: TourActionTypes.MARK_WIZARD_STEP_SEEN,
  payload: step,
})

export const dismissWizardTour = (): IDismissWizardTour => ({
  type: TourActionTypes.DISMISS_WIZARD_TOUR,
})

export const markDashboardTourSeen = (): IMarkDashboardTourSeen => ({
  type: TourActionTypes.MARK_DASHBOARD_TOUR_SEEN,
})

export const dismissDashboardTour = (): IDismissDashboardTour => ({
  type: TourActionTypes.DISMISS_DASHBOARD_TOUR,
})

export const markRestartCycleTourSeen = (): IMarkRestartCycleTourSeen => ({
  type: TourActionTypes.MARK_RESTART_CYCLE_TOUR_SEEN,
})

export const markTimerCardTourSeen = (): IMarkTimerCardTourSeen => ({
  type: TourActionTypes.MARK_TIMER_CARD_TOUR_SEEN,
})

export const markTimerFullScreenTourSeen = (): IMarkTimerFullScreenTourSeen => ({
  type: TourActionTypes.MARK_TIMER_FULLSCREEN_TOUR_SEEN,
})
